// extracted by mini-css-extract-plugin
export default {"loginContainer":"VerificationOtp_loginContainer__rKOzP","loginContainers":"VerificationOtp_loginContainers__ZGbC7","inputOTPContainer":"VerificationOtp_inputOTPContainer__Jjkk9"};